/* eslint-disable consistent-return */
import { Auth } from 'aws-amplify';
import { handleResponse, handleBlobResponse, handleError } from './api-utils';
import { isEmpty } from '../../components/utils/obj-utils';
import { apiConstants } from './api-constants';
import { formConstants } from '../../components/utils/constants/form-constants';
import { throttle, THROTTLE_TIME_INTERVAL, THROTTLE_RETRY_ATTEMPTS } from '../../../../general/js/helpers';
import userService from '../../../../general/js/user/user-service';
import api, { isResponseHandled } from '../../../../general/js/api';
import { SECUTIX_CONTACT_ID } from '../../../../general/js/user/constants';


export function getSSOUpgradeToOneClubFormData() {
    return fetch(`${window.location.origin}${apiConstants.loadSSOUpgradeToOneClubFormDataUrl}`)
        .then(handleResponse)
        .catch(handleError);
}

export function getHomePageTicketsData(callbackUrl, ssoDomain) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        const secutixContactNumber = userService.getDataFromLocalStorage(SECUTIX_CONTACT_ID);

        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify({
                [formConstants.website]: ssoDomain,
                secuTixContactNumber: secutixContactNumber

            })
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function getUserAccountData(callbackUrl) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        return fetch(callbackUrl, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function getOrderHistoryPages(callbackUrl, { displayCancelledFiles, ssoDomain }) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify({
                [formConstants.website]: ssoDomain,
                displayCancelledFiles
            })
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function getUserOrderHistoryData(callbackUrl,
    { pageNumber, displayCancelledFiles, ssoDomain }) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        const realPageNumber = isEmpty(pageNumber) ? 1 : pageNumber;
        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify({
                pageNumber: realPageNumber,
                displayCancelledFiles,
                [formConstants.website]: ssoDomain,
            })
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function getUserTicketsData(callbackUrl, hideOldTickets, ssoDomain) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        const secutixContactNumber = userService.getDataFromLocalStorage(SECUTIX_CONTACT_ID);

        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify({
                [formConstants.website]: ssoDomain,
                hideOldTickets,
                secuTixContactNumber: secutixContactNumber
            })
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function downloadPdfFile(callbackUrl, printOptions) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify(printOptions)
        })
            .then(handleBlobResponse)
            .catch(handleError);
    });
}

export function updateUserDetails(userDetails, callbackUrl) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        return fetch(callbackUrl, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify(userDetails)
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function updateUserDetailsPost(userDetails, callbackUrl) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify(userDetails)
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function updateEmailNotificationSettings(userDetails, callbackUrl) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify(userDetails)
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function getOrderDetails(callbackUrl, { fileNumber, ssoDomain }) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify({ fileNumber, [formConstants.website]: ssoDomain })
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function removeAccount(callbackUrl) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            }
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function changeUserPassword(passwordDetails, callbackUrl) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify(passwordDetails)
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function getVerifyEmailForm() {
    return fetch(apiConstants.verifyEmailFormDataUrl)
        .then(handleResponse)
        .catch(handleError);
}

export function resumePaymentByFileNumber(callbackUrl, { fileNumber, ssoDomain }) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;
        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify({ fileNumber, [formConstants.website]: ssoDomain })
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function authUserInSecutix(secutixAuthUrl) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;

        return fetch(secutixAuthUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function authUserInResaleSecutix({
    resaleTicketsUrl,
    requestUrl,
    secutixPointOfSaleId,
    secutixVirtualOperator,
    redirectUri
}) {
    return new Promise(async (resolve, reject) => {
        const token = await userService.getUserAccessToken();

        throttle(() => api.post(requestUrl, {
            resaleTicketsUrl,
            secutixPointOfSaleId,
            secutixVirtualOperator,
            redirectUri
        }, {
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${token}`
            }
        }), THROTTLE_TIME_INTERVAL, THROTTLE_RETRY_ATTEMPTS)
            .then((response) => {
                if (!isResponseHandled(response)) {
                    return reject(new Error('unknown result from async data'));
                }

                resolve();
            }, (error) => {
                if (error && error.code && error.code === 429) {
                    return reject(new Error('429'));
                }
                return reject();
            });
    });
}

export function authUserInBallotSecutix(callbackUrl) {
    return new Promise(async (resolve, reject) => {
        const token = await userService.getUserAccessToken();
        throttle(() => api.post(callbackUrl, null, {
            headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }), THROTTLE_TIME_INTERVAL, THROTTLE_RETRY_ATTEMPTS)
            .then((response) => {
                if (!isResponseHandled(response)) {
                    return reject(new Error('unknown result from async data'));
                }

                resolve();
            }, (error) => {
                if (error && error.code && error.code === 429) {
                    return reject(new Error('429'));
                }
                return reject();
            });
    });
}

export function updateOneClubMembershipStatus(callbackUrl) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;

        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify(true)
        })
            .then(handleResponse)
            .catch(handleError);
    });
}


export function agreeToPrivacyPolicyAndTermsAndConditions(callbackUrl, agreePrivaciPolicy, agreeTermsAndConditions) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;

        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
            body: JSON.stringify({
                agreedToPrivacyPolicy: agreePrivaciPolicy,
                agreedToTermsAndConditions: agreeTermsAndConditions
            })
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function addMasterCardMembership(callbackUrl) {
    return Auth.currentSession().then((data) => {
        const { accessToken } = data;

        return fetch(callbackUrl, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: `Bearer ${accessToken.jwtToken}`
            },
        })
            .then(handleResponse)
            .catch(handleError);
    });
}

export function saveUserToAddressBook(saveUserToAddressBookRequest, callbackUrl) {
    return fetch(callbackUrl, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(saveUserToAddressBookRequest)
    })
        .then(handleResponse)
        .catch(handleError);
}
